import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProducts(ctx, queryParams) {
      console.log('queryProduct', queryParams)
      const payload = {
        pagination: {
          total: 0,
          current: 0,
          pageSize: 500,
        },
        search: {
          name: null,
          startPrice: null,
          endPrice: null,
          shopId: null,
          categoryId: null,
        },
        sort: {
          predicate: 'product_name',
          reverse: true,
        },
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Product/GetList`, payload)
          .then(response => {
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'productId',
              sortDesc = false,
              status,
              plan,
            } = queryParams


            let dataFromAPI = response.data.data.list
            if (status) {
              dataFromAPI = dataFromAPI.filter(user => user.isActive == (status == 'active'))
            }
            if (plan) {
              dataFromAPI = dataFromAPI.filter(user => user.categoryName == plan)
            }

            // const filteredData = dataFromAPI.filter(
            //   user =>
            //     user && user.id
            //     // user && user.productName.toLowerCase().includes(queryLowered)  || user.categoryName.toLowerCase().includes(queryLowered)
            // )

            if (q !== '' && q !== null) {
              const queryLowered = q.toLowerCase()
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                const productCode = x.productCode || ''
                const name = x.name || ''
                const categoryName = x.categoryName || ''
                const price = x.price || ''
                const stockQuantity = x.stockQuantity || ''
                const totalQuantity = x.totalQuantity || ''

                if (productCode.toString().toLowerCase().includes(queryLowered)
                || name.toString().toLowerCase().includes(queryLowered)
                || categoryName.toString().toLowerCase().includes(queryLowered)
                || price.toString().toLowerCase().includes(queryLowered)
                || stockQuantity.toString().toLowerCase().includes(queryLowered)
                || totalQuantity.toString().toLowerCase().includes(queryLowered)
                ) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }

            const filteredData = dataFromAPI

            const sortedData = filteredData.sort(sortCompare(sortBy))
            if (sortDesc) sortedData.reverse()

            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: filteredData.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchProduct(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Product/GetById`, {
            params: {
              id,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addProduct(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/Product/AddOrUdpate`, { userData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteProduct(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Product/Delete`, {
            params: {
              productId: id,
              status,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getCategory() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/Category/Get`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
